import { FilterOptionItem } from '@src/design-system/filter-new';
import type { TRenderOptionItemCtx } from '../../types/filter-config';
import type { TStage } from '@src/shared/types/stage';

export function StageFilterOptionItem({
  selected,
  item,
  onToggle,
}: TRenderOptionItemCtx<TStage>) {
  return (
    <FilterOptionItem
      selected={selected}
      onClick={onToggle}
    >
      {item.name}
    </FilterOptionItem>
  );
}
